import { useEffect, useState } from "react";
import fetchWithCredentials from "apiClient";

interface SummaryStats {
  mensajes: number;
  casos: number;
  incidentes: number;
}

type PeriodType = "7_days" | "30_days";

interface SummaryStatsResponse {
  messages: number;
  cases: number;
  incidents: number;
}

export function useSummaryStats(
  period: PeriodType,
  selectedCondoIds: number[]
) {
  const [summaryStats, setSummaryStats] = useState<SummaryStats>({
    mensajes: 0,
    casos: 0,
    incidentes: 0,
  });

  useEffect(() => {
    async function fetchSummaryStats() {
      try {
        // Build URL with condo parameters
        let url = `/manager-api/reports/stats/?period=${period}`;
        if (selectedCondoIds.length > 0) {
          const condoParams = selectedCondoIds.map((id) => `condo=${id}`).join("&");
          url += `&${condoParams}`;
        }

        const response: SummaryStatsResponse = await fetchWithCredentials(url);

        setSummaryStats({
          mensajes: response.messages || 0,
          casos: response.cases || 0,
          incidentes: response.incidents || 0,
        });
      } catch (err) {
        console.error("Error loading summary stats:", err);
      }
    }

    fetchSummaryStats();
  }, [period, selectedCondoIds]);

  return summaryStats;
}
